import { createContext } from 'react';

var SystemContext = /*#__PURE__*/createContext({});

export { SystemContext };
